import { render, staticRenderFns } from "./HEART.vue?vue&type=template&id=4ae1a36e&scoped=true&"
import script from "./HEART.vue?vue&type=script&lang=js&"
export * from "./HEART.vue?vue&type=script&lang=js&"
import style0 from "./HEART.vue?vue&type=style&index=0&id=4ae1a36e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae1a36e",
  null
  
)

export default component.exports